import React from 'react';
import { Link } from 'react-router-dom';
import { Fade } from "react-awesome-reveal";
import './Welcome.css';

const Welcome = ( {name, handleNameChange}) => {
    return (
        <center className="welcome">
            <Fade cascade direction="right" >
                {name.length ===0?<div className="welcome-header">Welcome to foundation School</div>: <div className="welcome-header">Hey, {name}</div>}
            </Fade>
            <Fade cascade cascade direction="bottom-left">
                <div className="start-test">
                <input className="name-input"  value={name} onChange={(e) => handleNameChange(e.target.value)} placeholder="Enter you full names" />
                <Link className="start-button" to="/test" >Start test</Link>
            </div>
            </Fade>
            
        </center>
    )
}

export default Welcome
